import { motion } from "framer-motion";
import { Mic, Clapperboard, Sparkles, Podcast, Smartphone, Globe } from "lucide-react";

const WORLDS = [
  {
    icon: Mic,
    title: "Keynotes & Stages",
    desc: "Sold-out auditoriums, expos, and symposiums across the United States and Canada.",
  },
  {
    icon: Clapperboard,
    title: "Documentary & Film",
    desc: "Beyond the Grave alongside Dr. Eben Alexander — nominated at the Beverly Hills Film Festival.",
  },
  {
    icon: Sparkles,
    title: "Retreats & Workshops",
    desc: "A sold-out Spirit Encounter at the Omega Institute in Rhinebeck, New York — Esalen Institute ahead.",
  },
  {
    icon: Podcast,
    title: "The Podcast",
    desc: "Infinite Life, Infinite Wisdom — 19,000+ monthly listeners around the world.",
  },
  {
    icon: Smartphone,
    title: "My Infinite App",
    desc: "63+ spirit-led rooms for healing, ritual, and growth — at myinfinite.app.",
  },
  {
    icon: Globe,
    title: "The Community",
    desc: "A global circle of 160,000+ followers walking the healing path together.",
  },
];

export default function WorldOfSusan() {
  return (
    <section id="world" data-testid="world-section" className="relative overflow-hidden bg-[#F7F1E6] py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-body text-[0.65rem] font-medium uppercase tracking-[0.5em] text-[#C5A059]"
        >
          Beyond the Stage
        </motion.p>
        <div className="mt-6 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1, ease: [0.76, 0, 0.24, 1] }}
            className="font-display text-4xl font-light leading-tight tracking-tighter text-[#6B5D4F] sm:text-5xl lg:text-6xl"
          >
            The Infinite World <br />
            <span className="italic text-[#C5A059]">of Susan</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.2 }}
            className="max-w-md font-body text-base font-light leading-relaxed text-[#8B7D6B]"
          >
            One mission, many rooms — every way audiences meet Susan leaves them changed.
          </motion.p>
        </div>

        <div className="mt-16 border-t border-[#6B5D4F]/10">
          {WORLDS.map((w, i) => (
            <motion.div
              key={w.title}
              data-testid={`world-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.76, 0, 0.24, 1] }}
              className="group grid grid-cols-12 items-baseline gap-4 border-b border-[#6B5D4F]/10 py-9"
            >
              <span className="col-span-2 font-display text-xl italic text-[#C5A059] md:col-span-1">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="col-span-10 font-display text-3xl font-light tracking-tight text-[#6B5D4F] transition-transform duration-500 group-hover:translate-x-2 md:col-span-4 md:text-4xl">
                {w.title}
              </h3>
              <p className="col-span-10 col-start-3 font-body text-sm font-light leading-relaxed text-[#8B7D6B] md:col-span-6 md:col-start-6 md:text-base">
                {w.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
